import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FbTeamMembersDashboardCardService {

  constructor(private httpClient: HttpClient) { }

  getTeamMembers() {
    return this.httpClient.get(`/vd/formBuilder/dashboard/employee/teamMembers`)
      .pipe(
        map((response: any) => {
          if (response?.data?.length > 0 && response?.status === 200) {
            return response.data;
          } else {
            return []
          }
        }),
        catchError(error => {
          return of([]);
        })
      );
  }
}
